const BOOKS = {
	story1: {
		title: 'Radici di futuro',
		kind: 'NATURA',
		cities: 'Milano, Il Cairo, Rapa Nui',
	},
	story2: {
		title: 'Le parole inventano mondi',
		kind: 'SCRITTURA',
		cities: 'Pechino, Istanbul, Rio de Janeiro',
	},
	story3: {
		title: 'Scoprire è crescere',
		kind: 'MATEMATICA & MUSICA',
		cities: 'Washington DC, Parigi, Sydney',
	},
	story4: {
		title: 'Crea il tuo mondo',
		kind: 'ARTE & ARCHITETTURA',
		cities: 'Barcellona, New York, Mosca',
	},
};

export default BOOKS;
